// axiosSetup.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true, // Important for cookies to be sent with requests
});

// Flag to prevent multiple refresh token requests
let isRefreshing = false;
// Queue of failed requests to retry after token refresh
let failedQueue = [];

// Process the queue of failed requests
const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// Function to refresh the access token using HTTP-only cookie
// const refreshToken = async () => {
//   try {
//     // No need to send refresh token in the request body as it's in the HTTP-only cookie
//     const response = await axios.post(
//       `${import.meta.env.VITE_API_URL}/refresh-token`,
//       {}, // Empty body since the refresh token is in the cookie
//       {
//         withCredentials: true, // Important to include cookies
//         headers: {
//           "Cache-Control": "no-cache",
//           Pragma: "no-cache",
//         },
//       }
//     );

//     const { access_token } = response.data;

//     // Store the access token in both localStorage and sessionStorage

//     sessionStorage.setItem("authToken", access_token);

//     return access_token;
//   } catch (error) {
//     console.error("Error refreshing token:", error);
//     // Clear both storage locations on error

//     sessionStorage.removeItem("authToken");
//     throw error;
//   }
// };

export const setupInterceptors = (navigate) => {
  // Request interceptor to add auth token to all requests
  axiosInstance.interceptors.request.use(
    (config) => {
      // Check both storage locations for token
      const token = sessionStorage.getItem("authToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        // Add cache control headers to prevent caching of authenticated requests
        config.headers["Cache-Control"] = "no-cache";
        config.headers["Pragma"] = "no-cache";
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor to handle token refresh
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // If error is 401 and we haven't tried to refresh the token yet
      // if (error.response?.status === 401 && !originalRequest._retry) {
      //   if (isRefreshing) {
      //     // If already refreshing, add request to queue
      //     return new Promise((resolve, reject) => {
      //       failedQueue.push({ resolve, reject });
      //     })
      //       .then((token) => {
      //         originalRequest.headers["Authorization"] = `Bearer ${token}`;
      //         return axiosInstance(originalRequest);
      //       })
      //       .catch((err) => Promise.reject(err));
      //   }

      //   originalRequest._retry = true;
      //   isRefreshing = true;

      //   try {
      //     const newToken = await refreshToken();
      //     processQueue(null, newToken);
      //     originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
      //     return axiosInstance(originalRequest);
      //   } catch (refreshError) {
      //     processQueue(refreshError, null);
      //     // If refresh token fails, redirect to login
      //     navigate("/login");
      //     // Only clear access token, not cookies (server will handle cookie clearing)
      //     localStorage.removeItem("authToken");
      //     return Promise.reject(refreshError);
      //   } finally {
      //     isRefreshing = false;
      //   }
      // }

      // For 403 or other auth errors that aren't handled by refresh
      if (
        error.response &&
        (error.response.status === 403 ||
          (error.response.status === 401 && originalRequest._retry))
      ) {
        navigate("/login");
        // Only clear access token, not cookies (server will handle cookie clearing)
        localStorage.removeItem("authToken");
      }

      return Promise.reject(error);
    }
  );
};

export default axiosInstance;
